import axios from 'axios'

class SparrowService {
  constructor() {
    this.apiBase = axios.create({
      baseURL: '/api/v1',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
      },
      withCredentials: true, // For CSRF token and same-origin requests
    })
  }

  async fetchTargetAreas(externalIds, { token, sparrowApiUrl } = {}) {
    try {
      if (!externalIds || externalIds.length === 0) {
        throw new Error('No external IDs provided')
      }

      if (token && sparrowApiUrl) {
        // Send as array params (external_ids[]=uuid1&external_ids[]=uuid2)
        // Sparrow's Rails controller does .where(external_id: params[:external_ids])
        // which requires an array for IN queries, not a comma-separated string
        const response = await axios.get(`${sparrowApiUrl}/v2/target_areas`, {
          params: { 'external_ids[]': externalIds },
          headers: { Authorization: `Bearer ${token}` },
        })
        return response.data
      }

      // Fallback: iMetrics proxy (used when token is unavailable)
      const response = await this.apiBase.get(`/target_areas?external_ids=${externalIds.join(',')}`)
      if (response.data.error) throw new Error(response.data.error)
      return response.data
    } catch (error) {
      console.error('Error fetching target areas:', error)
      throw error
    }
  }

  async fetchCountryStats(countryIso3Code) {
    try {
      if (!countryIso3Code) {
        throw new Error('No country ISO3 code provided')
      }

      const response = await this.apiBase.get(`/countries/${countryIso3Code}/stats`)
      
      if (response.data.error) {
        throw new Error(response.data.error)
      }

      return response.data
    } catch (error) {
      console.error('Error fetching country stats:', error)
      throw error
    }
  }
}

export default new SparrowService()